module.exports = __webpack_public_path__ + "static/media/Ellipsis-red.48b9152f.svg";